import { PropsWithChildren, ReactElement } from "react";
import { Circle, HStack, Tab, Text } from "@chakra-ui/react";

const TabHeading = ({
  children,
  indicator,
}: PropsWithChildren<{
  indicator?: boolean;
}>): ReactElement => (
  <Tab>
    <HStack spacing={1} align="center">
      <Text textStyle="h4" color="grey.500" fontWeight="black">
        {children}
      </Text>
      {indicator && <Circle size={2} bg="warningRed" />}
    </HStack>
  </Tab>
);

export default TabHeading;
